// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__UcR4X","input":"SearchBar_input__yRUhB","icon":"SearchBar_icon__Co30N"};